module.exports = __webpack_public_path__ + "img/export.6bcf8dc5.svg";